module.exports = __webpack_public_path__ + "img/hero_fullwidth2.854372d5.png";